import { Layout } from '@/utils/routerHelper'
import cateringAppRoutes from './catering-app'
import cateringEmbeddedRoutes from './catering-embedded'
import daikeAppRoutes from './daike'
import canteenRoutes from './canteen'
import carCashierRoutes from './car-cashier'
import scenicStandaloneRoutes from './scenic-standalone'
import finStandaloneRoutes from './fin-standalone'
import microsceneStandaloneRoutes from './microscene-standalone'
import questionnaireStandaloneRoutes from './questionnaire-standalone'
import scrmRoutes from './scrm'
import foodRoutes from './food'
import iotRoutes from './iot'
import crmRoutes from './crm'
// 营销中心隐藏页（活动编辑/详情/预览），菜单主体由 system_menu 动态生成
import promotionRoutes from './promotion'
/**
 * redirect: noredirect        当设置 noredirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'          设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 * meta : {
 hidden: true              当设置 true 的时候该路由不会再侧边栏出现 如404，login等页面(默认 false)
 alwaysShow: true          当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式，
 只有一个时，会将那个子路由当做根路由显示在侧边栏，
 若你想不管路由下面的 children 声明的个数都显示你的根路由，
 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，
 一直显示根路由(默认 false)
 title: 'title'            设置该路由在侧边栏和面包屑中展示的名字
 icon: 'svg-name'          设置该路由的图标
 noCache: true             如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
 breadcrumb: false         如果设置为false，则不会在breadcrumb面包屑中显示(默认 true)
 affix: true               如果设置为true，则会一直固定在tag项中(默认 false)
 noTagsView: true          如果设置为true，则不会出现在tag中(默认 false)
 activeMenu: '/dashboard'  显示高亮的路由路径
 followAuth: '/dashboard'  跟随哪个路由进行权限过滤
 canTo: true               设置为true即使hidden为true，也依然可以进行路由跳转(默认 false)
 }
 **/
const remainingRouter: AppRouteRecordRaw[] = [
  {
    // 小区大屏全屏版：新窗口打开，不套管理端 Layout
    path: '/property/big-screen/full',
    component: () => import('@/views/property/bigScreen/full.vue'),
    name: 'PropertyBigScreenFull',
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    // 县级监管大屏全屏版（DataV）
    path: '/property/supervision-screen/full',
    component: () => import('@/views/property/supervisionScreen/full.vue'),
    name: 'PropertySupervisionScreenFull',
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/property/handover',
    component: Layout,
    name: 'PropertyHandoverRoot',
    meta: { hidden: true, canTo: true },
    children: [
      {
        path: 'index',
        name: 'PropertyHandover',
        component: () => import('@/views/property/handover/index.vue'),
        meta: {
          hidden: true,
          canTo: true,
          title: '交房',
          activeMenu: '/property/simplifyAcceptance/index'
        }
      }
    ]
  },
  {
    path: '/property/ownerExitRoom',
    component: Layout,
    name: 'PropertyOwnerExitRoomRoot',
    meta: { hidden: true, canTo: true },
    children: [
      {
        path: 'index',
        name: 'PropertyOwnerExitRoom',
        component: () => import('@/views/property/ownerExitRoom/index.vue'),
        meta: {
          hidden: true,
          canTo: true,
          title: '退房',
          activeMenu: '/property/simplifyAcceptance/index'
        }
      }
    ]
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'RedirectRoot',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/home',
    component: Layout,
    name: 'AdminHomeRoot',
    meta: {},
    children: [
      {
        path: '',
        component: () => import('@/views/Home/Index.vue'),
        name: 'AdminHome',
        meta: {
          title: '首页',
          icon: 'ep:house',
          noCache: false
        }
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    redirect: '/portal/home',
    name: 'Home',
    meta: {},
    children: [
      {
        path: 'index',
        component: () => import('@/views/workbench/Dashboard.vue'),
        name: 'Index',
        meta: {
          title: '仪表盘',
          icon: 'ep:data-board',
          noCache: false,
          closable: true
        }
      },
      {
        path: 'products',
        component: () => import('@/views/Products/index.vue'),
        name: 'Products',
        meta: { title: '产品中心', hidden: true }
      },
      {
        path: 'product-filter',
        component: () => import('@/views/product-filter/index.vue'),
        name: 'ProductFilter',
        meta: { title: '产品筛选配置', hidden: true, canTo: true }
      },
      {
        path: 'ai-tools',
        component: () => import('@/views/AiTools/index.vue'),
        name: 'AiTools',
        meta: { title: 'AI工具', hidden: true }
      },
      {
        path: 'ai-Application-center',
        component: () => import('@/views/AiAppCenter/index.vue'),
        name: 'AiApplicationCenter',
        meta: { title: 'AI应用', hidden: true }
      },
      {
        path: 'ai-business-center',
        component: () => import('@/views/AiBusinessCenter/index.vue'),
        name: 'AiBusinessCenter',
        meta: { title: 'AI中台', hidden: true }
      },
      {
        path: 'help',
        component: () => import('@/views/Help/index.vue'),
        name: 'Help',
        meta: { title: '帮助中心', hidden: true }
      },
      {
        path: 'help/:id',
        component: () => import('@/views/Help/detail.vue'),
        name: 'HelpDetail',
        meta: { title: '帮助详情', hidden: true, noTagsView: true }
      }
    ]
  },
  {
    path: '/ceo-cockpit',
    component: Layout,
    name: 'CeoCockpitRoot',
    meta: {},
    children: [
      {
        path: '',
        component: () => import('@/views/workbench/CeoCockpit.vue'),
        name: 'CeoCockpit',
        meta: {
          title: '总裁驾驶舱',
          icon: 'ep:data-analysis',
          noCache: false,
          closable: true
        }
      }
    ]
  },
  {
    path: '/template-management',
    component: Layout,
    name: 'WorkbenchTemplateManagementRoot',
    meta: {},
    children: [
      {
        path: '',
        component: () => import('@/views/workbench/management/TemplateManagement.vue'),
        name: 'WorkbenchTemplateManagement',
        meta: {
          title: '模板管理',
          icon: 'ep:brush',
          noCache: false,
          closable: true
        }
      },
      {
        path: 'mall',
        component: () => import('@/views/workbench/management/MallDecoration.vue'),
        name: 'WorkbenchMallDecoration',
        meta: {
          title: '移动端设计',
          hidden: true,
          canTo: true,
          noCache: true,
          closable: true,
          activeMenu: '/template-management'
        }
      }
    ]
  },
  {
    path: '/mini-program-management',
    component: Layout,
    name: 'WorkbenchMiniProgramManagementRoot',
    meta: {},
    children: [
      {
        path: '',
        component: () => import('@/views/workbench/management/DomainManagement.vue'),
        name: 'WorkbenchMiniProgramManagement',
        meta: {
          title: '小程序管理',
          icon: 'ep:iphone',
          noCache: false,
          closable: true
        }
      }
    ]
  },
  {
    path: '/wechat-shop',
    component: Layout,
    name: 'WorkbenchWechatShopRoot',
    meta: {},
    children: [
      {
        path: '',
        component: () => import('@/views/workbench/management/WechatShopManagement.vue'),
        name: 'WorkbenchWechatShop',
        meta: {
          title: '微信小店',
          icon: 'ep:shop',
          noCache: false,
          closable: true
        }
      }
    ]
  },
  {
    path: '/domain-management',
    component: Layout,
    name: 'WorkbenchDomainManagementRoot',
    meta: {},
    children: [
      {
        path: '',
        component: () => import('@/views/workbench/management/DomainManagement.vue'),
        name: 'WorkbenchDomainManagement',
        meta: {
          title: '域名管理',
          icon: 'ep:link',
          noCache: false,
          closable: true
        }
      }
    ]
  },
  {
    path: '/site-management',
    component: Layout,
    name: 'WorkbenchSiteManagementRoot',
    meta: {},
    children: [
      {
        path: '',
        component: () => import('@/views/cms/site/index.vue'),
        name: 'WorkbenchSiteManagement',
        meta: {
          title: '站点管理',
          icon: 'ep:monitor',
          noCache: false,
          closable: true
        }
      }
    ]
  },
  {
    path: '/workbench-banner',
    component: Layout,
    name: 'WorkbenchBannerRoot',
    meta: {},
    children: [
      {
        path: '',
        component: () => import('@/views/system/banner/index.vue'),
        name: 'WorkbenchBanner',
        meta: {
          title: '工作台轮播',
          icon: 'ep:picture',
          noCache: false,
          closable: true
        }
      }
    ]
  },
  {
    path: '/template-designer/:channel(mini|mobile|pc)',
    component: () => import('@/views/workbench/management/designer/ChannelDesigner.vue'),
    name: 'WorkbenchChannelDesigner',
    meta: {
      title: '商城模板设计',
      hidden: true,
      canTo: true,
      noTagsView: true
    }
  },
  // 仪表盘独立展示窗(新窗口打开,不带 Layout,纯净全屏展示)
  {
    path: '/dashboard-view',
    component: () => import('@/views/workbench/Dashboard.vue'),
    name: 'WorkbenchDashboardView',
    meta: {
      title: '仪表盘',
      hidden: true,
      canTo: true,
      noTagsView: true
    }
  },
  // 总裁驾驶舱独立展示窗(新窗口打开,不带 Layout,纯净全屏展示)
  {
    path: '/ceo-cockpit-view',
    component: () => import('@/views/workbench/CeoCockpit.vue'),
    name: 'WorkbenchCeoCockpitView',
    meta: {
      title: '总裁驾驶舱',
      hidden: true,
      canTo: true,
      noTagsView: true
    }
  },
  // 商城总裁驾驶舱独立展示窗（DataV 黑科技全屏，不带 Layout）
  {
    path: '/mall/cockpit-view',
    component: () => import('@/views/mall/home/index.vue'),
    name: 'MallCockpitView',
    meta: {
      title: '总裁驾驶舱',
      hidden: true,
      canTo: true,
      noTagsView: true
    }
  },
  // 活动总裁驾驶舱独立展示窗（DataV 全屏，不带 Layout）
  {
    path: '/activity/cockpit-view',
    component: () => import('@/views/activity/cockpit/index.vue'),
    name: 'ActivityCockpitView',
    meta: {
      title: '总裁驾驶舱',
      hidden: true,
      canTo: true,
      noTagsView: true
    }
  },
  {
    path: '/template-designer-preview/:channel(mini|mobile|pc)',
    component: () => import('@/views/workbench/management/designer/ChannelPreview.vue'),
    name: 'WorkbenchChannelDesignerPreview',
    meta: {
      title: '商城模板预览',
      hidden: true,
      canTo: true,
      noTagsView: true
    }
  },
  {
    path: '/hotel/design',
    component: Layout,
    name: 'HotelDesign',
    meta: {
      hidden: true
    },
    children: [
      {
        path: 'pc',
        component: () => import('@/views/hotel/design/pc.vue'),
        name: 'HotelPcDesign',
        meta: {
          title: '酒店管理 PC 端设计',
          hidden: true,
          activeMenu: '/hotel/dashboard',
          canTo: true
        }
      },
      {
        path: 'mobile',
        component: () => import('@/views/hotel/design/mobile.vue'),
        name: 'HotelMobileDesign',
        meta: {
          title: '酒店移动端设计',
          hidden: true,
          activeMenu: '/hotel/dashboard',
          canTo: true
        }
      }
    ]
  },
  {
    path: '/module/design',
    component: Layout,
    name: 'ModuleDesignRoot',
    meta: {
      hidden: true
    },
    children: [
      {
        path: '',
        component: () => import('@/views/moduleOverview/design.vue'),
        name: 'ModuleDesign',
        meta: {
          title: '模块页面设计',
          hidden: true,
          canTo: true
        }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    name: 'UserInfo',
    meta: {
      hidden: true
    },
    children: [
      {
        path: 'profile',
        component: () => import('@/views/Profile/Index.vue'),
        name: 'Profile',
        meta: {
          canTo: true,
          hidden: true,
          noTagsView: false,
          icon: 'ep:user',
          title: '个人中心'
        }
      },
      {
        path: 'notify-message',
        component: () => import('@/views/system/notify/my/index.vue'),
        name: 'MyNotifyMessage',
        meta: {
          canTo: true,
          hidden: true,
          noTagsView: false,
          icon: 'ep:message',
          title: '我的站内信'
        }
      }
    ]
  },
  {
    path: '/dict',
    component: Layout,
    name: 'dict',
    meta: {
      hidden: true
    },
    children: [
      {
        path: 'type/data/:dictType',
        component: () => import('@/views/system/dict/data/index.vue'),
        name: 'SystemDictData',
        meta: {
          title: '字典数据',
          noCache: true,
          hidden: true,
          canTo: true,
          icon: '',
          activeMenu: '/system/dict'
        }
      }
    ]
  },
  {
    path: '/codegen',
    component: Layout,
    name: 'CodegenEdit',
    meta: {
      hidden: true
    },
    children: [
      {
        path: 'edit',
        component: () => import('@/views/infra/codegen/EditTable.vue'),
        name: 'InfraCodegenEditTable',
        meta: {
          noCache: true,
          hidden: true,
          canTo: true,
          icon: 'ep:edit',
          title: '修改生成配置',
          activeMenu: 'infra/codegen/index'
        }
      }
    ]
  },
  {
    path: '/job',
    component: Layout,
    name: 'JobL',
    meta: {
      hidden: true
    },
    children: [
      {
        path: 'job-log',
        component: () => import('@/views/infra/job/logger/index.vue'),
        name: 'InfraJobLog',
        meta: {
          noCache: true,
          hidden: true,
          canTo: true,
          icon: 'ep:edit',
          title: '调度日志',
          activeMenu: 'infra/job/index'
        }
      }
    ]
  },
  {
    path: '/ticketing',
    component: Layout,
    name: 'TicketingHidden',
    meta: {
      hidden: true
    },
    children: [
      {
        path: 'platform/dashboard',
        component: () => import('@/views/ticketing/platform/dashboard/index.vue'),
        name: 'TicketingPlatformDashboardDirect',
        meta: {
          title: '概括',
          hidden: true,
          canTo: true,
          icon: 'ep:data-analysis'
        }
      },
      {
        path: 'product-create',
        component: () => import('@/views/ticketing/product/create.vue'),
        name: 'TicketingProductCreate',
        meta: {
          title: '新建商品',
          noCache: true,
          hidden: true,
          canTo: true,
          icon: 'ep:plus',
          activeMenu: '/ticketing/product'
        }
      },
      {
        path: 'product-form',
        component: () => import('@/views/ticketing/product/ProductForm.vue'),
        name: 'TicketingProductForm',
        meta: {
          title: '编辑商品',
          noCache: true,
          hidden: true,
          canTo: true,
          icon: 'ep:edit',
          activeMenu: '/ticketing/product'
        }
      }
    ]
  },
  // 独立登录页
  {
    path: '/login',
    component: () => import('@/views/Portal/LoginPage.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: '登录',
      noTagsView: true
    }
  },
  {
    path: '/portal',
    component: () => import('@/views/Portal/Login.vue'),
    name: 'Portal',
    redirect: '/portal/home',
    meta: {
      hidden: true,
      title: '紫金山AI',
      noTagsView: true
    },
    children: [
      {
        path: 'home',
        name: 'PortalHome',
        component: () => import('@/views/Portal/PortalHome.vue'),
        meta: { hidden: true, title: '首页', noTagsView: true }
      },
      {
        path: 'zjsclaw',
        name: 'PortalZjsClaw',
        component: () => import('@/views/Portal/pages/ZjsClawPage.vue'),
        meta: { hidden: true, title: 'ZJSClaw', noTagsView: true }
      },
      {
        path: 'products',
        name: 'PortalProducts',
        component: () => import('@/views/Portal/pages/ProductsPage.vue'),
        meta: { hidden: true, title: '产品中心', noTagsView: true }
      },
      {
        path: 'products/:id',
        name: 'PortalProductDetail',
        component: () => import('@/views/Portal/pages/ProductDetailPage.vue'),
        meta: { hidden: true, title: '产品详情', noTagsView: true }
      },
      {
        path: 'biz',
        name: 'PortalBiz',
        component: () => import('@/views/Portal/pages/BizPlatformPage.vue'),
        meta: { hidden: true, title: '业务中台', noTagsView: true }
      },
      {
        path: 'data',
        name: 'PortalData',
        component: () => import('@/views/Portal/pages/DataPlatformPage.vue'),
        meta: { hidden: true, title: '数据中台', noTagsView: true }
      },
      {
        path: 'solutions',
        name: 'PortalSolutions',
        component: () => import('@/views/Portal/pages/SolutionsPage.vue'),
        meta: { hidden: true, title: '解决方案', noTagsView: true }
      },
      {
        path: 'solutions/:tabKey/:slug',
        name: 'PortalSolutionPrototype',
        component: () => import('@/views/Portal/pages/solutions/SolutionPrototypeHost.vue'),
        meta: { hidden: true, title: '方案详情', noTagsView: true }
      },
      {
        path: 'solutions/:industry',
        name: 'PortalSolutionDetail',
        component: () => import('@/views/Portal/pages/SolutionDetailPage.vue'),
        meta: { hidden: true, title: '行业方案', noTagsView: true }
      },
      {
        path: 'partners',
        name: 'PortalPartners',
        component: () => import('@/views/Portal/pages/PartnersPage.vue'),
        meta: { hidden: true, title: '合作伙伴', noTagsView: true }
      },
      {
        path: 'about',
        name: 'PortalAbout',
        component: () => import('@/views/Portal/pages/AboutPage.vue'),
        meta: { hidden: true, title: '关于我们', noTagsView: true }
      },
      {
        path: 'contact',
        name: 'PortalContact',
        component: () => import('@/views/Portal/pages/ContactPage.vue'),
        meta: { hidden: true, title: '联系我们', noTagsView: true }
      },
      {
        path: 'careers',
        name: 'PortalCareers',
        component: () => import('@/views/Portal/pages/CareersPage.vue'),
        meta: { hidden: true, title: '加入我们', noTagsView: true }
      },
      {
        path: 'careers/:id',
        name: 'PortalCareerDetail',
        component: () => import('@/views/Portal/pages/CareerDetailPage.vue'),
        meta: { hidden: true, title: '职位详情', noTagsView: true }
      },
      {
        path: 'help-center',
        name: 'PortalHelpCenter',
        component: () => import('@/views/Portal/pages/HelpCenterPage.vue'),
        meta: { hidden: true, title: '帮助中心', noTagsView: true }
      },
      {
        path: 'events',
        name: 'PortalEvents',
        component: () => import('@/views/Portal/pages/EventsPage.vue'),
        meta: { hidden: true, title: '活动中心', noTagsView: true }
      },
      {
        path: 'events/:id',
        name: 'PortalEventDetail',
        component: () => import('@/views/Portal/pages/EventDetailPage.vue'),
        meta: { hidden: true, title: '活动详情', noTagsView: true }
      },
      {
        path: 'news',
        name: 'PortalNews',
        component: () => import('@/views/Portal/pages/NewsPage.vue'),
        meta: { hidden: true, title: '新闻公告', noTagsView: true }
      },
      {
        path: 'news/:id',
        name: 'PortalNewsDetail',
        component: () => import('@/views/Portal/pages/NewsDetailPage.vue'),
        meta: { hidden: true, title: '新闻详情', noTagsView: true }
      },
      {
        path: 'support',
        name: 'PortalSupport',
        component: () => import('@/views/Portal/pages/SupportPage.vue'),
        meta: { hidden: true, title: '服务支持', noTagsView: true }
      },
      {
        path: 'icp',
        name: 'PortalIcp',
        component: () => import('@/views/Portal/pages/IcpPage.vue'),
        meta: { hidden: true, title: '备案服务', noTagsView: true }
      },
      {
        path: 'free-trial',
        name: 'PortalFreeTrial',
        component: () => import('@/views/Portal/pages/FreeTrialPage.vue'),
        meta: { hidden: true, title: '免费试用', noTagsView: true }
      }
    ]
  },
  {
    path: '/store/login',
    component: () => import('@/views/merchant/auth/login.vue'),
    name: 'MerchantLogin',
    meta: {
      hidden: true,
      title: 'B端登录',
      noTagsView: true
    }
  },
  {
    path: '/agent-portal/login',
    component: () => import('@/views/agent-portal/auth/login.vue'),
    name: 'AgentPortalLogin',
    meta: { hidden: true, title: '渠道代理商登录', noTagsView: true }
  },
  {
    path: '/agent-apply',
    component: () => import('@/views/agent-portal/apply-redirect.vue'),
    name: 'AgentApplyPublicRedirect',
    meta: { hidden: true, title: '代理商入驻', noTagsView: true }
  },
  {
    path: '/agent-portal',
    component: () => import('@/views/agent-portal/AgentPortalLayout.vue'),
    name: 'AgentPortalLayout',
    redirect: '/agent-portal/workbench',
    meta: { hidden: true, title: '渠道代理商门户' },
    children: [
      {
        path: 'workbench',
        name: 'AgentPortalWorkbench',
        component: () => import('@/views/agent-portal/workbench/index.vue'),
        meta: { title: '工作台', noTagsView: true }
      },
      {
        path: 'merchants',
        name: 'AgentPortalMerchants',
        component: () => import('@/views/agent-portal/merchants/index.vue'),
        meta: { title: '名下商家', noTagsView: true }
      },
      {
        path: 'ledger',
        name: 'AgentPortalLedger',
        component: () => import('@/views/agent-portal/ledger/index.vue'),
        meta: { title: '分润明细', noTagsView: true }
      },
      {
        path: 'settle',
        name: 'AgentPortalSettle',
        component: () => import('@/views/agent-portal/settle/index.vue'),
        meta: { title: '结算单', noTagsView: true }
      },
      {
        path: 'account',
        name: 'AgentPortalAccount',
        component: () => import('@/views/agent-portal/account/index.vue'),
        meta: { title: '收款账户', noTagsView: true }
      },
      {
        path: 'subs',
        name: 'AgentPortalSubs',
        component: () => import('@/views/agent-portal/subs/index.vue'),
        meta: { title: '二级代理', noTagsView: true }
      }
    ]
  },
  {
    path: '/firm/login',
    component: () => import('@/views/firm-portal/auth/login.vue'),
    name: 'FirmPortalLogin',
    meta: {
      hidden: true,
      title: '律所机构登录',
      noTagsView: true
    }
  },
  {
    path: '/firm',
    component: () => import('@/views/firm-portal/FirmLayout.vue'),
    name: 'FirmLayout',
    redirect: '/firm/workbench',
    meta: { hidden: true },
    children: [
      {
        path: 'workbench',
        name: 'FirmWorkbench',
        component: () => import('@/views/firm-portal/workbench/index.vue'),
        meta: { title: '工作台', noTagsView: true }
      },
      {
        path: 'lawyer',
        name: 'FirmPortalLawyer',
        component: () => import('@/views/firm-portal/lawyer/index.vue'),
        meta: { title: '本所律师', noTagsView: true }
      },
      {
        path: 'opportunity',
        name: 'FirmPortalOpportunity',
        component: () => import('@/views/firm-portal/opportunity/index.vue'),
        meta: { title: '本所商机', noTagsView: true }
      },
      {
        path: 'case',
        name: 'FirmPortalCase',
        component: () => import('@/views/firm-portal/case/index.vue'),
        meta: { title: '本所案件', noTagsView: true }
      },
      {
        path: 'profile',
        name: 'FirmPortalProfile',
        component: () => import('@/views/firm-portal/profile/index.vue'),
        meta: { title: '本所资料', noTagsView: true }
      },
      {
        path: 'settle',
        name: 'FirmPortalSettle',
        component: () => import('@/views/firm-portal/settle/index.vue'),
        meta: { title: '结算', noTagsView: true }
      },
      {
        path: 'practice/dashboard',
        name: 'FirmPracticeDashboard',
        component: () => import('@/views/firm-portal/practice/dashboard/index.vue'),
        meta: { title: '办案驾驶舱', noTagsView: true }
      },
      {
        path: 'practice/customer',
        name: 'FirmPracticeCustomer',
        component: () => import('@/views/firm-portal/practice/customer/index.vue'),
        meta: { title: '客户', noTagsView: true }
      },
      {
        path: 'practice/matter',
        name: 'FirmPracticeMatter',
        component: () => import('@/views/firm-portal/practice/matter/index.vue'),
        meta: { title: '案件工作台', noTagsView: true }
      },
      {
        path: 'practice/time',
        name: 'FirmPracticeTime',
        component: () => import('@/views/firm-portal/practice/time/index.vue'),
        meta: { title: '工时', noTagsView: true }
      },
      {
        path: 'practice/dossier',
        name: 'FirmPracticeDossier',
        component: () => import('@/views/firm-portal/practice/dossier/index.vue'),
        meta: { title: '卷宗', noTagsView: true }
      },
      {
        path: 'practice/fee',
        name: 'FirmPracticeFee',
        component: () => import('@/views/firm-portal/practice/fee/index.vue'),
        meta: { title: '收费', noTagsView: true }
      },
      {
        path: 'practice/hearing',
        name: 'FirmPracticeHearing',
        component: () => import('@/views/firm-portal/practice/hearing/index.vue'),
        meta: { title: '开庭', noTagsView: true }
      },
      {
        path: 'practice/task',
        name: 'FirmPracticeTask',
        component: () => import('@/views/firm-portal/practice/task/index.vue'),
        meta: { title: '任务', noTagsView: true }
      },
      {
        path: 'practice/deadline',
        name: 'FirmPracticeDeadline',
        component: () => import('@/views/firm-portal/practice/deadline/index.vue'),
        meta: { title: '期限', noTagsView: true }
      },
      {
        path: 'practice/alert',
        name: 'FirmPracticeAlert',
        component: () => import('@/views/firm-portal/practice/alert/index.vue'),
        meta: { title: '预警', noTagsView: true }
      },
      {
        path: 'practice/invoice',
        name: 'FirmPracticeInvoice',
        component: () => import('@/views/firm-portal/practice/invoice/index.vue'),
        meta: { title: '开票', noTagsView: true }
      },
      {
        path: 'practice/refund',
        name: 'FirmPracticeRefund',
        component: () => import('@/views/firm-portal/practice/refund/index.vue'),
        meta: { title: '退费', noTagsView: true }
      },
      {
        path: 'practice/commission',
        name: 'FirmPracticeCommission',
        component: () => import('@/views/firm-portal/practice/commission/index.vue'),
        meta: { title: '提成', noTagsView: true }
      },
      {
        path: 'practice/retainer',
        name: 'FirmPracticeRetainer',
        component: () => import('@/views/firm-portal/practice/retainer/index.vue'),
        meta: { title: '顾问', noTagsView: true }
      },
      {
        path: 'practice/office/notice',
        name: 'FirmPracticeNotice',
        component: () => import('@/views/firm-portal/practice/office/notice/index.vue'),
        meta: { title: '公告', noTagsView: true }
      },
      {
        path: 'practice/office/doc',
        name: 'FirmPracticeDoc',
        component: () => import('@/views/firm-portal/practice/office/doc/index.vue'),
        meta: { title: '文档', noTagsView: true }
      },
      {
        path: 'practice/office/calendar',
        name: 'FirmPracticeCalendar',
        component: () => import('@/views/firm-portal/practice/office/calendar/index.vue'),
        meta: { title: '日历', noTagsView: true }
      },
      {
        path: 'practice/office/seal',
        name: 'FirmPracticeSeal',
        component: () => import('@/views/firm-portal/practice/office/seal/index.vue'),
        meta: { title: '公章', noTagsView: true }
      }
    ]
  },
  {
    path: '/supplier/login',
    component: () => import('@/views/supplier/login.vue'),
    name: 'SupplierLogin',
    meta: {
      hidden: true,
      title: '供应商登录',
      noTagsView: true
    }
  },
  {
    path: '/supplier',
    component: () => import('@/views/supplier/SupplierLayout.vue'),
    name: 'SupplierLayout',
    redirect: '/supplier/workbench',
    meta: { hidden: true, title: '供应商工作台', noTagsView: true },
    children: [
      {
        path: 'workbench',
        name: 'SupplierWorkbench',
        component: () => import('@/views/supplier/workbench/index.vue'),
        meta: { hidden: true, title: '工作台', noTagsView: true }
      },
      {
        path: 'drafts',
        name: 'SupplierDrafts',
        component: () => import('@/views/supplier/drafts/index.vue'),
        meta: { hidden: true, title: '新品提报', noTagsView: true }
      },
      {
        path: 'drafts/form',
        name: 'SupplierDraftForm',
        component: () => import('@/views/supplier/drafts/form/index.vue'),
        meta: { hidden: true, title: '提报商品', noTagsView: true }
      },
      {
        path: 'account',
        name: 'SupplierAccount',
        component: () => import('@/views/supplier/account/index.vue'),
        meta: { hidden: true, title: '账号管理', noTagsView: true }
      },
      {
        path: 'orders',
        name: 'SupplierOrders',
        component: () => import('@/views/supplier/orders/index.vue'),
        meta: { hidden: true, title: '订单管理', noTagsView: true }
      },
      {
        path: 'finance',
        name: 'SupplierFinance',
        component: () => import('@/views/supplier/finance/index.vue'),
        meta: { hidden: true, title: '对账报表', noTagsView: true }
      },
      {
        path: 'settle-preview',
        name: 'SupplierSettlePreview',
        component: () => import('@/views/supplier/finance/settlePreview.vue'),
        meta: { hidden: true, title: '应付货款预估', noTagsView: true }
      },
      {
        path: 'settle-bill',
        name: 'SupplierSettleBill',
        component: () => import('@/views/supplier/finance/settleBill.vue'),
        meta: { hidden: true, title: '结算单', noTagsView: true }
      }
    ]
  },
  // 旧 /merchant/** → /store/**
  {
    path: '/merchant/:pathMatch(.*)*',
    redirect: (to) => {
      const rest = to.params.pathMatch
      const suffix = Array.isArray(rest) ? rest.join('/') : rest || ''
      return suffix ? `/store/${suffix}` : '/store/workbench'
    },
    name: 'MerchantToStoreLegacy',
    meta: { hidden: true, noTagsView: true }
  },
  // P2：/b/** 别名 → /store
  {
    path: '/b/login',
    redirect: '/store/login',
    name: 'BGatewayLogin',
    meta: { hidden: true, noTagsView: true }
  },
  {
    path: '/b/apply',
    redirect: '/store/login',
    name: 'BGatewayApply',
    meta: { hidden: true, noTagsView: true }
  },
  {
    path: '/b/select-console',
    redirect: '/store/workbench',
    name: 'BGatewaySelectConsole',
    meta: { hidden: true, noTagsView: true }
  },
  {
    path: '/b/mall/:pathMatch(.*)*',
    redirect: (to) => {
      const rest = to.params.pathMatch
      const suffix = Array.isArray(rest) ? rest.join('/') : rest || 'dashboard'
      return '/store/' + suffix
    },
    name: 'BMallAlias',
    meta: { hidden: true, noTagsView: true }
  },
  {
    path: '/b/o2o/:pathMatch(.*)*',
    redirect: (to) => {
      const rest = to.params.pathMatch
      const suffix = Array.isArray(rest) ? rest.join('/') : rest || ''
      return '/store/o2o/' + suffix
    },
    name: 'BOtwoAlias',
    meta: { hidden: true, noTagsView: true }
  },
  {
    path: '/b/capacity/:pathMatch(.*)*',
    redirect: (to) => {
      const rest = to.params.pathMatch
      const suffix = Array.isArray(rest) ? rest.join('/') : rest || ''
      return '/store/capacity/' + suffix
    },
    name: 'BCapacityAlias',
    meta: { hidden: true, noTagsView: true }
  },
  {
    path: '/b/hotel/:pathMatch(.*)*',
    redirect: (to) => {
      const rest = to.params.pathMatch
      const suffix = Array.isArray(rest) ? rest.join('/') : rest || ''
      return '/store/hotel/' + suffix
    },
    name: 'BHotelAlias',
    meta: { hidden: true, noTagsView: true }
  },
  {
    path: '/store/b/apply',
    redirect: '/store/login',
    name: 'MerchantBApplyCatalog',
    meta: { hidden: true, title: '入驻目录已下线', noTagsView: true }
  },
  {
    path: '/store/b/select-console',
    redirect: '/store/workbench',
    name: 'MerchantBSelectConsoleDeprecated',
    meta: { hidden: true, title: '选台已下线', noTagsView: true }
  },
  // B 侧自助入驻已下线 → 登录；入驻改 A 端运营
  {
    path: '/store/o2o/institution/apply',
    redirect: '/store/login',
    name: 'MerchantO2oInstitutionApply',
    meta: { hidden: true, title: '机构入驻', noTagsView: true }
  },
  {
    path: '/store/capacity/apply',
    redirect: '/store/login',
    name: 'MerchantCapacityApply',
    meta: { hidden: true, title: '配送机构入驻', noTagsView: true }
  },
  {
    path: '/store',
    component: () => import('@/views/merchant/MerchantLayout.vue'),
    name: 'MerchantLayout',
    redirect: '/store/workbench',
    meta: { hidden: true, title: 'B端工作台' },
    children: [
      {
        path: 'workbench',
        component: () => import('@/views/merchant/workbench/index.vue'),
        name: 'MerchantWorkbenchHome',
        meta: { title: '工作台' }
      },
      {
        path: 'dashboard',
        component: () => import('@/views/merchant/dashboard/index.vue'),
        name: 'MerchantDashboard',
        meta: { title: '经营概况' }
      },
      {
        path: 'product',
        component: () => import('@/views/merchant/product/spu/index.vue'),
        name: 'MerchantProduct',
        meta: { title: '商品管理' }
      },
      {
        path: 'product/comment',
        component: () => import('@/views/merchant/product/comment/index.vue'),
        name: 'MerchantProductComment',
        meta: { title: '商品评价' }
      },
      {
        path: 'product/pool',
        component: () => import('@/views/merchant/product/pool/index.vue'),
        name: 'MerchantProductPool',
        meta: { title: '供应选品' }
      },
      {
        path: 'order',
        component: () => import('@/views/merchant/order/index.vue'),
        name: 'MerchantOrder',
        meta: { title: '订单管理' }
      },
      {
        path: 'order/verify',
        component: () => import('@/views/merchant/order/Verify.vue'),
        name: 'MerchantOrderVerify',
        meta: { title: '自提核销' }
      },
      {
        path: 'live/orders',
        component: () => import('@/views/merchant/live/orders/index.vue'),
        name: 'MerchantLiveOrders',
        meta: { title: '直播订单' }
      },
      {
        path: 'live/anchor',
        component: () => import('@/views/merchant/live/anchor/index.vue'),
        name: 'MerchantLiveAnchor',
        meta: { title: '直播主播' }
      },
      {
        path: 'live/commission',
        component: () => import('@/views/merchant/live/commission/index.vue'),
        name: 'MerchantLiveCommission',
        meta: { title: '直播佣金' }
      },
      {
        path: 'live/agreement',
        component: () => import('@/views/merchant/live/agreement/index.vue'),
        name: 'MerchantLiveAgreement',
        meta: { title: '直播协议' }
      },
      {
        path: 'live/settle',
        component: () => import('@/views/merchant/live/settle/index.vue'),
        name: 'MerchantLiveSettle',
        meta: { title: '直播结算' }
      },
      {
        path: 'live/product',
        component: () => import('@/views/merchant/live/product/index.vue'),
        name: 'MerchantLiveProduct',
        meta: { title: '直播商品' }
      },
      {
        path: 'live/activity',
        component: () => import('@/views/merchant/live/activity/index.vue'),
        name: 'MerchantLiveActivity',
        meta: { title: '直播活动' }
      },
      {
        path: 'scenic/order',
        component: () => import('@/views/merchant/scenic/order/index.vue'),
        name: 'MerchantScenicOrder',
        meta: { title: '景区订单' }
      },
      {
        path: 'scenic/spot',
        component: () => import('@/views/merchant/scenic/spot/index.vue'),
        name: 'MerchantScenicSpot',
        meta: { title: '景区管理' }
      },
      {
        path: 'kefu',
        component: () => import('@/views/merchant/kefu/index.vue'),
        name: 'MerchantShopKefu',
        meta: { title: '本店客服' }
      },
      {
        path: 'finance',
        component: () => import('@/views/merchant/finance/index.vue'),
        name: 'MerchantFinance',
        meta: { title: '财务管理' }
      },
      {
        path: 'finance/invoice',
        component: () => import('@/views/merchant/finance/invoice/index.vue'),
        name: 'MerchantFinanceInvoice',
        meta: { title: '发票管理' }
      },
      {
        path: 'finance/supplier-settle-preview',
        component: () => import('@/views/merchant/finance/supplierSettlePreview.vue'),
        name: 'MerchantSupplierSettlePreview',
        meta: { title: '供方预估' }
      },
      {
        path: 'finance/supplier-settle',
        component: () => import('@/views/merchant/finance/supplierSettle.vue'),
        name: 'MerchantSupplierSettle',
        meta: { title: '外发结算' }
      },
      {
        path: 'promotion',
        component: () => import('@/views/merchant/promotion/index.vue'),
        name: 'MerchantPromotion',
        meta: { title: '营销管理' }
      },
      {
        path: 'promotion/coupon-record',
        component: () => import('@/views/merchant/promotion/couponRecord.vue'),
        name: 'MerchantCouponRecord',
        meta: { hidden: true, title: '领取记录' }
      },
      {
        path: 'promotion/bargain-record',
        component: () => import('@/views/merchant/promotion/bargainRecord.vue'),
        name: 'MerchantBargainRecord',
        meta: { hidden: true, title: '砍价记录' }
      },
      {
        path: 'promotion/combination-record',
        component: () => import('@/views/merchant/promotion/combinationRecord.vue'),
        name: 'MerchantCombinationRecord',
        meta: { hidden: true, title: '拼团记录' }
      },
      {
        path: 'shop',
        component: () => import('@/views/merchant/shop/index.vue'),
        name: 'MerchantShop',
        meta: { title: '店铺管理' }
      },
      {
        path: 'belonging',
        component: () => import('@/views/merchant/belonging/index.vue'),
        name: 'MerchantBelonging',
        meta: { title: '归属代理' }
      },
      {
        path: 'belonging/confirm',
        component: () => import('@/views/merchant/belonging/confirm.vue'),
        name: 'MerchantBelongingConfirm',
        meta: { title: '归属确认' }
      },
      // 子账号管理
      {
        path: 'member/sub-account',
        component: () => import('@/views/merchant/member/sub-account/index.vue'),
        name: 'MerchantSubAccount',
        meta: { title: '员工管理' }
      },
      // 经营类目
      {
        path: 'shop/category',
        component: () => import('@/views/merchant/shop/category.vue'),
        name: 'MerchantShopCategory',
        meta: { title: '经营类目' }
      },
      // 快递运费模板（商家端）
      {
        path: 'shop/express-template',
        component: () => import('@/views/merchant/delivery/expressTemplate/index.vue'),
        name: 'MerchantExpressTemplate',
        meta: { title: '运费模版' }
      },
      // 本店自提点（一店一点）
      {
        path: 'shop/pick-up-store',
        component: () => import('@/views/merchant/delivery/pickUpStore/index.vue'),
        name: 'MerchantPickUpStore',
        meta: { title: '自提网点' }
      },
      // 社区团购（主体开通 MALL_GROUPBUY）
      {
        path: 'groupbuy/activity',
        component: () => import('@/views/merchant/groupbuy/activity/index.vue'),
        name: 'MerchantGroupbuyActivity',
        meta: { title: '团购活动' }
      },
      {
        path: 'groupbuy/pickup-point',
        component: () => import('@/views/merchant/groupbuy/pickup-point/index.vue'),
        name: 'MerchantGroupbuyPickupPoint',
        meta: { title: '团购自提' }
      },
      {
        path: 'groupbuy/leader',
        component: () => import('@/views/merchant/groupbuy/leader/index.vue'),
        name: 'MerchantGroupbuyLeader',
        meta: { title: '团长审核' }
      },
      {
        path: 'groupbuy/driver',
        component: () => import('@/views/merchant/groupbuy/driver/index.vue'),
        name: 'MerchantGroupbuyDriver',
        meta: { title: '司机审核' }
      },
      {
        path: 'groupbuy/batch',
        component: () => import('@/views/merchant/groupbuy/batch/index.vue'),
        name: 'MerchantGroupbuyBatch',
        meta: { title: '批次台账' }
      },
      {
        path: 'groupbuy/report',
        component: () => import('@/views/merchant/groupbuy/report/index.vue'),
        name: 'MerchantGroupbuyReport',
        meta: { title: '团购对账' }
      },
      // 商品新增/编辑表单（商家端，不在菜单显示）
      {
        path: 'product/form',
        component: () => import('@/views/merchant/product/spu/form/index.vue'),
        name: 'MerchantProductForm',
        meta: { hidden: true, title: '商品表单' }
      },
      {
        // B 端专用 name，禁止与 A 端 mall.ts 的 MerchantApplyDetail 撞名，
        // 否则 push({ name: 'MerchantApplyDetail' }) 会盖掉管理端 Layout 路由，独立窗详情整页无菜单。
        path: 'apply/detail/:id(\\d+)',
        component: () => import('@/views/mall/apply/detail.vue'),
        name: 'StoreMerchantApplyDetail',
        meta: {
          hidden: true,
          canTo: true,
          title: '入驻审核详情',
          activeMenu: '/shop-manager/merchant-apply'
        }
      },
      // O2O 上门服务（B 端）
      {
        path: 'o2o/institution/profile',
        component: () => import('@/views/merchant/o2o/institution/profile/index.vue'),
        name: 'MerchantO2oInstitutionProfile',
        meta: { title: '机构信息' }
      },
      {
        path: 'o2o/order',
        component: () => import('@/views/merchant/o2o/order/index.vue'),
        name: 'MerchantO2oOrder',
        meta: { title: '服务订单' }
      },
      {
        path: 'o2o/provider',
        component: () => import('@/views/merchant/o2o/provider/index.vue'),
        name: 'MerchantO2oProvider',
        meta: { title: '员工管理' }
      },
      {
        path: 'o2o/store',
        component: () => import('@/views/merchant/o2o/store/index.vue'),
        name: 'MerchantO2oStore',
        meta: { title: '门店管理' }
      },
      {
        path: 'o2o/reservation',
        component: () => import('@/views/merchant/o2o/reservation/index.vue'),
        name: 'MerchantO2oReservation',
        meta: { title: '预约管理' }
      },
      {
        path: 'o2o/review',
        component: () => import('@/views/merchant/o2o/review/index.vue'),
        name: 'MerchantO2oReview',
        meta: { title: '评价管理' }
      },
      {
        path: 'o2o/pricing/apply',
        component: () => import('@/views/merchant/o2o/pricing/apply.vue'),
        name: 'MerchantO2oPricingApply',
        meta: { title: '服务定价' }
      },
      {
        path: 'o2o/dispute',
        component: () => import('@/views/merchant/o2o/dispute/index.vue'),
        name: 'MerchantO2oDispute',
        meta: { title: '纠纷记录' }
      },
      {
        path: 'o2o/finance',
        component: () => import('@/views/merchant/o2o/finance/index.vue'),
        name: 'MerchantO2oFinance',
        meta: { title: '机构财务' }
      },
      {
        path: 'o2o/dashboard',
        component: () => import('@/views/merchant/o2o/dashboard/index.vue'),
        name: 'MerchantO2oDashboard',
        meta: { title: '数据看板' }
      },
      // 众包运力 · 机构 Web（入驻页在 Layout 外独立路由）
      {
        path: 'capacity/profile',
        component: () => import('@/views/merchant/capacity/profile/index.vue'),
        name: 'MerchantCapacityProfile',
        meta: { title: '机构信息' }
      },
      {
        path: 'capacity/dashboard',
        component: () => import('@/views/merchant/capacity/dashboard/index.vue'),
        name: 'MerchantCapacityDashboard',
        meta: { title: '运力概览' }
      },
      {
        path: 'capacity/invite',
        component: () => import('@/views/merchant/capacity/invite/index.vue'),
        name: 'MerchantCapacityInvite',
        meta: { title: '邀请与入驻' }
      },
      {
        path: 'capacity/dispatch',
        component: () => import('@/views/merchant/capacity/dispatch/index.vue'),
        name: 'MerchantCapacityDispatch',
        meta: { title: '运单监控' }
      },
      {
        path: 'capacity/settle',
        component: () => import('@/views/merchant/capacity/settle/index.vue'),
        name: 'MerchantCapacitySettle',
        meta: { title: '分润对账' }
      },
      {
        path: 'hotel/onboarding',
        component: () => import('@/views/merchant/hotel/onboarding/index.vue'),
        name: 'MerchantHotelOnboarding',
        meta: { title: '酒店入驻' }
      },
      {
        path: 'hotel/dashboard',
        component: () => import('@/views/merchant/hotel/operation/index.vue'),
        name: 'MerchantHotelDashboard',
        meta: { title: '经营看板', hotelSection: 'dashboard' }
      },
      {
        path: 'hotel/room-types',
        component: () => import('@/views/merchant/hotel/operation/index.vue'),
        name: 'MerchantHotelRoomTypes',
        meta: { title: '房型与价型', hotelSection: 'room-types' }
      },
      {
        path: 'hotel/rooms',
        component: () => import('@/views/merchant/hotel/operation/index.vue'),
        name: 'MerchantHotelRooms',
        meta: { title: '实体房间', hotelSection: 'rooms' }
      },
      {
        path: 'hotel/inventory',
        component: () => import('@/views/merchant/hotel/operation/index.vue'),
        name: 'MerchantHotelInventory',
        meta: { title: '日历量价', hotelSection: 'inventory' }
      },
      {
        path: 'hotel/orders',
        component: () => import('@/views/merchant/hotel/operation/index.vue'),
        name: 'MerchantHotelOrders',
        meta: { title: '预订订单', hotelSection: 'orders' }
      },
      {
        path: 'hotel/check-in',
        component: () => import('@/views/merchant/hotel/operation/index.vue'),
        name: 'MerchantHotelCheckIn',
        meta: { title: '入住办理', hotelSection: 'orders' }
      },
      {
        path: 'hotel/services',
        component: () => import('@/views/merchant/hotel/operation/index.vue'),
        name: 'MerchantHotelServices',
        meta: { title: '客房服务', hotelSection: 'services' }
      },
      {
        path: 'hotel/finance',
        component: () => import('@/views/merchant/hotel/operation/index.vue'),
        name: 'MerchantHotelFinance',
        meta: { title: '酒店财务', hotelSection: 'finance' }
      },
      {
        path: 'hotel/settings',
        component: () => import('@/views/merchant/hotel/operation/index.vue'),
        name: 'MerchantHotelSettings',
        meta: { title: '运营策略', hotelSection: 'settings' }
      },
      {
        path: 'hotel/channel',
        component: () => import('@/views/merchant/hotel/management/index.vue'),
        name: 'MerchantHotelChannel',
        meta: { title: '公众号与小程序', hotelSection: 'channel' }
      },
      {
        path: 'hotel/content',
        component: () => import('@/views/merchant/hotel/management/index.vue'),
        name: 'MerchantHotelContent',
        meta: { title: '酒店介绍与装修', hotelSection: 'content' }
      },
      {
        path: 'hotel/members',
        component: () => import('@/views/merchant/hotel/management/index.vue'),
        name: 'MerchantHotelMembers',
        meta: { title: '酒店会员', hotelSection: 'members' }
      },
      {
        path: 'hotel/rent-policy',
        component: () => import('@/views/merchant/hotel/management/index.vue'),
        name: 'MerchantHotelRentPolicy',
        meta: { title: '租期与价格规则', hotelSection: 'rent-policy' }
      },
      {
        path: 'hotel/coupons',
        component: () => import('@/views/merchant/hotel/management/index.vue'),
        name: 'MerchantHotelCoupons',
        meta: { title: '优惠券发放', hotelSection: 'coupons' }
      },
      {
        path: 'rental/product',
        component: () => import('@/views/merchant/rental/product/index.vue'),
        name: 'MerchantRentalProduct',
        meta: { title: '租赁商品' }
      },
      // 玄学机构台（B 端，机构入驻审核通过后可见；MVP 空壳占位）
      {
        path: 'xuanxue/institution',
        component: () => import('@/views/merchant/xuanxue/institution/index.vue'),
        name: 'MerchantXuanxueInstitution',
        meta: { title: '机构资料' }
      },
      // 玄学机构台-旗下师傅（挂靠管理：申请审核/解聘）
      {
        path: 'xuanxue/affiliation',
        component: () => import('@/views/merchant/xuanxue/affiliation/index.vue'),
        name: 'MerchantXuanxueAffiliation',
        meta: { title: '旗下师傅' }
      },
      // 玄学机构台-高端服务（服务配置/派单/机构钱包）
      {
        path: 'xuanxue/premium',
        component: () => import('@/views/merchant/xuanxue/premium/index.vue'),
        name: 'MerchantXuanxuePremium',
        meta: { title: '高端服务' }
      }
    ]
  },
  {
    path: '/visiting/decorate',
    component: Layout,
    name: 'O2oDecorateRoot',
    meta: {
      hidden: true
    },
    children: [
      {
        path: 'consumer',
        name: 'O2oConsumerDecorate',
        component: () => import('@/views/o2o/decorate/consumer/index.vue'),
        meta: {
          title: '用户端装修',
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/visiting/dashboard'
        }
      },
      {
        path: 'provider',
        name: 'O2oProviderDecorate',
        component: () => import('@/views/o2o/decorate/provider/index.vue'),
        meta: {
          title: '上门端装修',
          noCache: true,
          hidden: true,
          canTo: true,
          activeMenu: '/visiting/dashboard'
        }
      }
    ]
  },
  // A 端旧书签 /o2o/* → /visiting/*（勿伤 /store/o2o、/b/o2o）
  {
    path: '/o2o/:pathMatch(.*)*',
    redirect: (to) => {
      const rest = to.params.pathMatch
      const suffix = Array.isArray(rest) ? rest.join('/') : rest || ''
      const query = { ...to.query }
      if (query.app === 'o2o') {
        query.app = 'visiting'
      }
      return {
        path: suffix ? `/visiting/${suffix}` : '/visiting',
        query,
        hash: to.hash
      }
    },
    name: 'O2oToVisitingAlias',
    meta: { hidden: true, noTagsView: true }
  },
  // 旧入口缺 platform 段：/distribution/{leaf} → /distribution/platform/{leaf}
  // 概况快捷入口 / 个别硬编码曾写无 platform 的路径；侧栏菜单已是 platform/*
  {
    path: '/distribution/:leaf(overview|cockpit|waybill|org|mock|reconcile|penalty|compensate|rider-mgmt|rider-cert|settle|ops)',
    redirect: (to) => ({
      path: `/distribution/platform/${to.params.leaf}`,
      query: to.query,
      hash: to.hash
    }),
    name: 'DistributionPlatformLeafAlias',
    meta: { hidden: true, noTagsView: true }
  },
  // A 端旧书签 /capacity/* → /distribution/*（勿伤 /store/capacity、/b/capacity）
  {
    path: '/capacity/:pathMatch(.*)*',
    redirect: (to) => {
      const rest = to.params.pathMatch
      const suffix = Array.isArray(rest) ? rest.join('/') : rest || ''
      const query = { ...to.query }
      if (query.app === 'capacity') {
        query.app = 'distribution'
      }
      return {
        path: suffix ? `/distribution/${suffix}` : '/distribution',
        query,
        hash: to.hash
      }
    },
    name: 'CapacityToDistributionAlias',
    meta: { hidden: true, noTagsView: true }
  },
  {
    path: '/sso',
    redirect: '/portal/home',
    name: 'SSOLogin',
    meta: {
      hidden: true,
      title: '登录',
      noTagsView: true
    }
  },
  {
    path: '/wecom-entry',
    component: () => import('@/views/Portal/WeComEntry.vue'),
    name: 'WeComEntry',
    meta: {
      hidden: true,
      title: '企业微信登录',
      noTagsView: true
    }
  },
  {
    path: '/social-login',
    component: () => import('@/views/Portal/SocialLogin.vue'),
    name: 'SocialLogin',
    meta: {
      hidden: true,
      title: '社交登录',
      noTagsView: true
    }
  },
  {
    path: '/403',
    component: () => import('@/views/Error/403.vue'),
    name: 'NoAccess',
    meta: {
      hidden: true,
      title: '403',
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFound',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  },
  {
    path: '/500',
    component: () => import('@/views/Error/500.vue'),
    name: 'Error',
    meta: {
      hidden: true,
      title: '500',
      noTagsView: true
    }
  },
  // AI智慧景区独立路由组（新窗口打开路径：/scenicarea）
  ...scenicStandaloneRoutes,
  // 投融资独立路由组（新窗口打开路径：/investment）
  ...finStandaloneRoutes,
  // 微场景独立路由组（新窗口打开路径：/scene）
  ...microsceneStandaloneRoutes,
  // 问卷调查独立路由组（新窗口打开路径：/questionnaire）
  ...questionnaireStandaloneRoutes,
  // 餐饮管理系统独立路由组（不走 yudao Layout，独立 SSO 登录态）
  // 必须放在 catch-all 之前，否则会被 /:pathMatch(.*)* 抢先匹配
  ...cateringAppRoutes,
  // AI智慧餐饮统一管理别名路由（AI应用中心卡片同窗入口 /catering/dashboard → 菜单真实路由）
  ...foodRoutes,
  // AI智慧餐饮壳内旧功能页（/ai-Application-center/catering/repast/*，留在壳内渲染，避免切到 repast 独立壳）
  ...cateringEmbeddedRoutes,
  // AI智慧收银独立路由（新窗口打开路径：/canteen/home）
  ...canteenRoutes,
  // 紫金餐厅独立路由也必须放在 catch-all 之前
  ...daikeAppRoutes,
  // 汽车会员收银全屏路由（views/car-cashier，与 car 同级）
  ...carCashierRoutes,
  // SCRM 详情等隐藏路由，菜单主体由 system_menu 动态生成
  ...scrmRoutes,
  // IoT 产品/设备/固件 详情等隐藏路由，菜单主体由 system_menu 动态生成
  ...iotRoutes,
  // CRM 详情等隐藏路由（客户/线索/商机/合同/回款/回款计划/联系人/产品）
  // 菜单主体由 system_menu 动态生成；这里只为「点列表行 → 详情」提供 name 路由。
  // 必须放在 catch-all 之前，否则 push({ name: 'CrmXxxDetail' }) 会被 /:pathMatch(.*)* 抢走 → 404。
  ...crmRoutes,
  // 营销中心活动编辑/详情/预览等隐藏页，菜单主体由 system_menu 动态生成
  ...promotionRoutes,
  // 律师详情：不在 system_menu；独立绝对路径避免与 AI 中心 stub 父路由冲突
  {
    path: '/lawyer/lawyer/detail',
    component: Layout,
    name: 'LawyerLawyerDetailLayout',
    meta: { hidden: true },
    children: [
      {
        path: '',
        name: 'LawyerLawyerDetail',
        component: () => import('@/views/lawyer/lawyer/detail.vue'),
        meta: {
          hidden: true,
          canTo: true,
          title: '律师详情',
          activeMenu: '/lawyer/lawyer',
          noCache: true
        }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/Error/404.vue'),
    name: '',
    meta: {
      title: '404',
      hidden: true,
      breadcrumb: false
    }
  }
]
export default remainingRouter
